module.exports = __webpack_public_path__ + "img/motion-detector-lg.5c697626.svg";